module.exports = __webpack_public_path__ + "static/img/menager.a1c8e67e.png";